const getDefaultState = () => {
  return {
    notifications: [],
  };
};

const state = getDefaultState();

// Synchronous
const mutations = {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },

  ADD_NEW_NOTIFICATION(state, notification) {
    state.notifications.push(notification);
  },

  REMOVE_NOTIFICATION(state, identifier) {
    const index = state.notifications.findIndex((obj) => obj.identifier === identifier);
    state.notifications.splice(index, 1);
  },
};

// Asynchronous
const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },

  addNewNotification({ commit }, notification) {
    commit("ADD_NEW_NOTIFICATION", notification);
  },

  removeNotification({ commit }, identifier) {
    commit("REMOVE_NOTIFICATION", identifier);
  },
};

const notifier = {
  namespaced: true,

  state,
  mutations,
  actions,
};

export default notifier;
